import GATSBY_COMPILED_MDX from "/home/lsimon/dev/node/anulu/src/content/ml/index.md";
import React from 'react';
import {graphql} from 'gatsby';
import Seo from '../../components/seo';
import Layout from "../../components/post-layout.js";
const Page = ({data: {mdx}, children}) => {
  return Layout({
    children
  }, mdx);
};
export const query = graphql`
  query ($id: String) {
    mdx(id: { eq: $id }) {
      frontmatter {
        title
      }
    }
  }
`;
Page
export default function GatsbyMDXWrapper(props) {
  return React.createElement(Page, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const Head = ({data: {mdx: {frontmatter: {title}}}}) => {
  return React.createElement(Seo, {
    title: title
  });
};
